import { memo, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Markdown } from '@Sage/hoi-poi-ui';

import { SageService } from 'services';
import { logEvent } from 'utils/tracking';
import { getLiteral } from 'utils/getLiteral';
import SageSyncIllustration from './SageSyncIllustration';

import './styles.scss';

const mapStateToProps = (state) => {
    return {
        productModeCode: state.config?.productModeCode,
    };
};

const TOTAL_DURATION_TO_SHOW_MODAL = 60 * 24;

const SageSyncNotification = memo(({ productModeCode }) => {
    const [isOpen, setIsOpen] = useState(false);

    const onConfirm = useCallback(() => {
        setIsOpen(false);
        logEvent({
            event: 'unspecified',
            submodule: 'sageSyncModalError',
            functionality: 'acceptAlert',
        });
    }, []);

    const onRequestClose = useCallback(() => {
        setIsOpen(false);
        logEvent({
            event: 'unspecified',
            submodule: 'sageSyncModalError',
            functionality: 'closeAlert',
        });
    }, []);

    useEffect(() => {
        window.addEventListener('beforeunload', (e) => {
            if (sessionStorage.getItem('sage_tab_control')) {
                localStorage.removeItem('sage_tab_control');
                sessionStorage.removeItem('sage_tab_control');
            }
        });
    }, []);

    useEffect(() => {
        if (!productModeCode?.includes('sage')) return;
        SageService.getSageSync()
            .then(({ data }) => {
                const date = data.stoppedDuration;
                const shouldShowModal = data.status === 'stopped';
                if (shouldShowModal && date) {
                    setIsOpen(data.stoppedDuration > TOTAL_DURATION_TO_SHOW_MODAL);
                } else {
                    setIsOpen(false);
                }
            })
            .catch((e) => {
                console.error(e);
            });
    }, [productModeCode]);

    if (!productModeCode?.includes('sage')) return null;

    return (
        <Modal
            className="fm-sage-notification-modal"
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            onConfirm={onConfirm}
            confirmText={getLiteral('action_understood')}
            title={getLiteral('label_modal_information_integration')}
            isConfirmLoading={false}
        >
            <div className="fm-sage-notification-modal__content">
                <SageSyncIllustration className="fm-sage-notification-modal__illustration" />
                <Markdown
                    content={getLiteral('label_modal_information_integration_markdown_desc')}
                    overrides={{
                        a: { type: 'caption', target: '_blank' },
                    }}
                />
            </div>
        </Modal>
    );
});
export default connect(mapStateToProps)(SageSyncNotification);
